
<row>
  <column>
    <label :for="filterElement.idForProp('filter')">
      {{filterElement.label_title}}
    </label>
    <br>
    <input
      v-model="isOn"
      :id="filterElement.idForProp('filter')"
      type="checkbox"
      class="toggle-btn">
  </column>
</row>
